import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VBodyScrollLock from 'v-body-scroll-lock'

import 'jquery-ui/themes/base/datepicker.css'
import 'jquery-ui/themes/base/theme.css'

import VueGtm from '@gtm-support/vue2-gtm'

import { func } from './mixins/globalfunctions'
Vue.prototype.$func = func

require('jquery-ui/ui/widgets/datepicker.js')

Vue.use(VueTelInput)
Vue.config.productionTip = false

Vue.use(VBodyScrollLock)

Vue.use(VueGtm, {
  id: 'GTM-5Q9TGQ82',
  vueRouter: router,
  enabled: true,
  debug: true,
  loadScript: false
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Heroku-24 stack
